import {smartLabelsEnabled} from '@netx/core-attribute-smart-labels/enablers/smartLabelsEnabled';
import {Locales} from '@netx/core-locales/utils/Locales';
import {i18n} from '@netx/core-locales';

////////////////////////////////////////
// Asset searches
////////////////////////////////////////
export let assets = {
	sortFields: {
		// Expiration date gets inserted in search controller init if expiration is enabled
		// TODO: Make sort fields a collection that can handle user prefs and events - also, then we can have compartors and sort these things in the DOM
		// this list gets concated with user defined attribute names and things get out of order
		// https://jira.netx.net/browse/DAM-9364
		// expirationDate   : i18n.t('i18n.expirationDate'),
		file: i18n.t('i18n.file'),
		name: i18n.t('i18n.name'),
		assetId: i18n.t('i18n.assetId'),
		fileFormatFamily: i18n.t('i18n.fileFormatFamily'),
		fileSize2: i18n.t('i18n.fileSize'),
		filetypelabel: i18n.t('i18n.fileType'),
		height: i18n.t('i18n.height'),
		importDate: i18n.t('i18n.importDate'),
		moddate: i18n.t('i18n.modDate'),
		creationdate: i18n.t('i18n.creationDate'),
		dimensions: i18n.t('i18n.dimensions'),
		relevance: i18n.t('i18n.relevance'),
		width: i18n.t('i18n.width'),
	},
};

// Will be concated with date attributes (on attributes fetch) and applied to assets.elementSubType1s.Date.options
export let dateSubTypes1_default = [
	{
		label: i18n.t('i18n.creationDate'),
		val: 0,
	},
	{
		label: i18n.t('i18n.lastModified'),
		val: 1,
	},
	// Type 2 is for searching date attributes, where value3 is set to the attribute name.
	// Type 2 is only avialable when there are attribute templates of date type (See: Netx.Collections.Attributes)
	{
		label: i18n.t('i18n.importDate'),
		val: 3,
	},
	{
		label: i18n.t('i18n.expirationDate'),
		val: 4,
	},
];
////////////////////////////////////////
// !Asset searches
////////////////////////////////////////

////////////////////////////////////////
// Attribute searches
////////////////////////////////////////
export let attributes = {
	elementTypes: {
		type: 'Select',
		options: [
			{
				label: i18n.t('i18n.cart'),
				val: 10,
			},
		],
	},
	elementSubType1s: {
		// Cart
		10: {},
	},
	elementSubType2s: {
		// Cart
		10: {},
	},
	elementValue1s: {
		// Cart
		10: {
			type: 'Text',
		},
	},
	elementValue2s: {
		// Cart
		10: {},
	},
	elementValue3s: {
		// Cart
		10: {},
	},
};
////////////////////////////////////////
// !Attribute searches
////////////////////////////////////////

////////////////////////////////////////
// Clip searches
////////////////////////////////////////
export let clips = {
	elementTypes: {
		type: 'Select',
		options: [
			{
				label: i18n.t('i18n.keywords'),
				val: 101,
			},
			{
				label: i18n.t('i18n.assets'),
				val: 102,
			},
			{
				label: i18n.t('i18n.attributes'),
				val: 101,
			},
		],
	},
	elementSubType1s: {
		// Keywords
		// Attributes
		101: {
			type: 'Select',
			options: [
				{
					label: i18n.t('i18n.matchAllWildcardsAND'),
					val: 4,
				},
				{
					label: i18n.t('i18n.matchAnyWildcardsOR'),
					val: 5,
				},
				{
					label: i18n.t('i18n.matchExactly'),
					val: 1,
				},
				{
					label: i18n.t('i18n.matchAllWords'),
					val: 0,
				},
				{
					label: i18n.t('i18n.matchAnyWholeWordsOR'),
					val: 2,
				},
				{
					label: i18n.t('i18n.matchEmpty'),
					val: 6,
				},
				{
					label: i18n.t('i18n.matchAnyRange'),
					val: 9,
				},
			],
		},
		// Assets
		102: {},
	},
	elementSubType2s: {
		// Keywords
		// Attributes
		101: {},
		// Assets
		102: {},
	},
	elementValue1s: {
		// Keywords
		// Attributes
		101: {
			type: 'Text',
		},
		// Assets
		102: {
			type: 'Text',
		},
	},
	elementValue3s: {
		// Keywords
		// Attributes
		101: {},
		// Assets
		102: {},
	},
	sortFields: {
		startTime: i18n.t('i18n.startTime'),
		endTime: i18n.t('i18n.endTime'),
		title: i18n.t('i18n.title'),
	},
};
////////////////////////////////////////
// !Clip searches
////////////////////////////////////////

////////////////////////////////////////
// Facets
////////////////////////////////////////
// Search types facets support
export let facetSupports = [
	1, // Keyword
	2, // Contents
	3, // Metadata
	4, // Date
	5, // Category name
	6, // File format
	7, // File size
	8, // Advanced raw
	10, // Cart
	13, // Checkouts
	14, // Thesaurus - no longer a thing really but still there
	22, // File aspect
	23, // Category id
	24, // Saved search
	26, // File format family
	27, // Visual search
	28, // Active templates
	200, // Attribute history
];

// Translation/readability
export const systemFacetOptions = Locales((i18n) => ({
	'creationDate.older': i18n('i18n.older'),
	'creationDate.pastMonth': i18n('i18n.pastMonth'),
	'creationDate.pastWeek': i18n('i18n.pastWeek'),
	'creationDate.pastYear': i18n('i18n.pastYear'),
	'creationDate.today': i18n('i18n.today'),
	'fileSize.extraLarge': i18n('i18n.extraLarge'),
	'fileSize.large': i18n('i18n.large'),
	'fileSize.medium': i18n('i18n.medium'),
	'fileSize.small': i18n('i18n.small'),
	'fileSize.tiny': i18n('i18n.tiny'),
	'importDate.older': i18n('i18n.older'),
	'importDate.pastMonth': i18n('i18n.pastMonth'),
	'importDate.pastYear': i18n('i18n.pastYear'),
	'importDate.pastWeek': i18n('i18n.pastWeek'),
	'importDate.today': i18n('i18n.today'),
	'modificationDate.older': i18n('i18n.older'),
	'modificationDate.pastMonth': i18n('i18n.pastMonth'),
	'modificationDate.pastWeek': i18n('i18n.pastWeek'),
	'modificationDate.pastYear': i18n('i18n.pastYear'),
	'modificationDate.today': i18n('i18n.today'),
}));

// These are system provided facets
export const systemFacets = Locales((i18n) => ({
	creationDate: i18n('i18n.created'),
	fileFormatFamily: i18n('i18n.type'),
	fileSize: i18n('i18n.size'),
	fileType: i18n('i18n.extension'),
	folder: i18n('i18n.folder'),
	category: i18n('i18n.category'),
	importDate: i18n('i18n.imported'),
	modificationDate: i18n('i18n.modified'),
}));
////////////////////////////////////////
// !Facets
////////////////////////////////////////

// Populated by the search module when it initializes.
export let fileFormatFamilies = {};

// Populated by the search module when it initializes.
export let fileTypes = {};

// For saved search notification
export let notificationTypes = {
	0: i18n.t('i18n.none'),
	1: i18n.t('i18n.weekly'),
	2: i18n.t('i18n.daily'),
	3: i18n.t('i18n.immediately'),
};

// Properties that can be updated manually
export let searchProperties = [
	'sortField',
	'sortOrder',
	'matchCriteria',
	'saveSearch',
	'notifyType',
	'ignoreStat',
	'startPosition',
	// 'maxItems' // hands off maxItems!  use chunkSize/pageSize instead.
];

// TODO: The cms module in portal that is grabbing this file too early (prior to having user prefs)
// we need to clean that up at some point as we should not be grabbing things from other modules
// until prefs are returned form the server (for a variety of reasons)
//
// For anything that waits for prefs before loading this file
if (smartLabelsEnabled()) {
	assets.sortFields['smart labels'] = i18n.t('i18n.smartLabels');
}
// For portal
dispatcher.once('app:user:prefs:ready', () => {
	if (smartLabelsEnabled()) {
		assets.sortFields['smart labels'] = i18n.t('i18n.smartLabels');
	}
});

export default {
	assets,
	attributes,
	clips,
	dateSubTypes1_default,
	facetSupports,
	fileFormatFamilies,
	fileTypes,
	notificationTypes,
	searchProperties,
	systemFacetOptions,
	systemFacets,
};
